import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import PokemonCard from './components/PokemonCard';
import CustomizationPanel from './components/CustomizationPanel';
import { Analytics } from '@vercel/analytics/react';
import { createSprite, nextZ, CARD_W, CARD_H } from './spriteEngine';

export const POKEMON = [
  {
    id: 'pikachu', label: 'Pikachu',
    sprite: 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/25.webp',
    type: 'Electric', hp: 60,
    atk1: { name: 'Thunder Shock', dmg: 20, desc: 'Flip a coin. If tails, this attack does nothing.' },
    atk2: { name: 'Agility',       dmg: 30, desc: 'Flip a coin. If heads, prevent all effects of attacks, including damage, done to this Pokémon.' },
  },
  {
    id: 'charmander', label: 'Charmander',
    sprite: 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/4.webp',
    type: 'Fire', hp: 50,
    atk1: { name: 'Scratch', dmg: 10, desc: 'Nothing special happens.' },
    atk2: { name: 'Ember',   dmg: 30, desc: 'Flip a coin. If tails, Charmander does 10 damage to itself.' },
  },
  {
    id: 'squirtle', label: 'Squirtle',
    sprite: 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/7.webp',
    type: 'Water', hp: 40,
    atk1: { name: 'Bubble',   dmg: 10, desc: 'Flip a coin. If heads, the Defending Pokémon is now Paralyzed.' },
    atk2: { name: 'Withdraw', dmg: 0,  desc: "Flip a coin. If heads, prevent all damage done to Squirtle during your opponent's next turn." },
  },
  {
    id: 'bulbasaur', label: 'Bulbasaur',
    sprite: 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/1.webp',
    type: 'Grass', hp: 45,
    atk1: { name: 'Vine Whip',  dmg: 20, desc: 'Lash out with long vines to damage.' },
    atk2: { name: 'Leech Seed', dmg: 20, desc: 'Unless all damage from this attack is prevented, remove 1 damage counter from Bulbasaur.' },
  },
  {
    id: 'eevee', label: 'Eevee',
    sprite: 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/133.webp',
    type: 'Normal', hp: 50,
    atk1: { name: 'Tail Whap',    dmg: 10, desc: 'Nothing special happens.' },
    atk2: { name: 'Quick Attack', dmg: 30, desc: 'Flip a coin. If tails, this attack does 10 damage instead of 30.' },
  },
];

export const POKEMON_SPRITES = [
  'BULBASAUR', 'CHARIZARD', 'Charmander', 'CHIKORITA', 'CHIMCHAR',
  'CUBONE', 'CYNDAQUIL', 'Ditto', 'Eevee', 'ESPEON', 'Gengar',
  'GRENINJA', 'grookey', 'jiggly puff', 'LUCARIO', 'magikarp',
  'mew', 'Mimikyu', 'MUDKIP', 'OSHAWOTT', 'pichu', 'Pikachu',
  'PIPLUP', 'Psyduck', 'rowlet', 'SLOWPOKE', 'SNORLAX',
  'Squirtle A', 'Squirtle B', 'Squirtle', 'SYLVEON', 'TORCHIC',
  'TOTODILE', 'turtwig', 'UMBREON',
  // Gen 1-3 (#1-386) fill-ins — official PokeAPI artwork, added for everything in
  // that range not already covered by the custom-art names above.
  'Ivysaur', 'Venusaur', 'Charmeleon', 'Wartortle', 'Blastoise', 'Caterpie', 'Metapod', 'Butterfree', 'Weedle', 'Kakuna', 'Beedrill', 'Pidgey', 'Pidgeotto', 'Pidgeot', 'Rattata', 'Raticate', 'Spearow', 'Fearow', 'Ekans', 'Arbok', 'Raichu', 'Sandshrew', 'Sandslash', 'Nidoran F', 'Nidorina', 'Nidoqueen', 'Nidoran M', 'Nidorino', 'Nidoking', 'Clefairy', 'Clefable', 'Vulpix', 'Ninetales', 'Wigglytuff', 'Zubat', 'Golbat', 'Oddish', 'Gloom', 'Vileplume', 'Paras', 'Parasect', 'Venonat', 'Venomoth', 'Diglett', 'Dugtrio', 'Meowth', 'Persian', 'Golduck', 'Mankey', 'Primeape', 'Growlithe', 'Arcanine', 'Poliwag', 'Poliwhirl', 'Poliwrath', 'Abra', 'Kadabra', 'Alakazam', 'Machop', 'Machoke', 'Machamp', 'Bellsprout', 'Weepinbell', 'Victreebel', 'Tentacool', 'Tentacruel', 'Geodude', 'Graveler', 'Golem', 'Ponyta', 'Rapidash', 'Slowbro', 'Magnemite', 'Magneton', 'Farfetchd', 'Doduo', 'Dodrio', 'Seel', 'Dewgong', 'Grimer', 'Muk', 'Shellder', 'Cloyster', 'Gastly', 'Haunter', 'Onix', 'Drowzee', 'Hypno', 'Krabby', 'Kingler', 'Voltorb', 'Electrode', 'Exeggcute', 'Exeggutor', 'Marowak', 'Hitmonlee', 'Hitmonchan', 'Lickitung', 'Koffing', 'Weezing', 'Rhyhorn', 'Rhydon', 'Chansey', 'Tangela', 'Kangaskhan', 'Horsea', 'Seadra', 'Goldeen', 'Seaking', 'Staryu', 'Starmie', 'Mr Mime', 'Scyther', 'Jynx', 'Electabuzz', 'Magmar', 'Pinsir', 'Tauros', 'Gyarados', 'Lapras', 'Vaporeon', 'Jolteon', 'Flareon', 'Porygon', 'Omanyte', 'Omastar', 'Kabuto', 'Kabutops', 'Aerodactyl', 'Articuno', 'Zapdos', 'Moltres', 'Dratini', 'Dragonair', 'Dragonite', 'Mewtwo', 'Bayleef', 'Meganium', 'Quilava', 'Typhlosion', 'Croconaw', 'Feraligatr', 'Sentret', 'Furret', 'Hoothoot', 'Noctowl', 'Ledyba', 'Ledian', 'Spinarak', 'Ariados', 'Crobat', 'Chinchou', 'Lanturn', 'Cleffa', 'Igglybuff', 'Togepi', 'Togetic', 'Natu', 'Xatu', 'Mareep', 'Flaaffy', 'Ampharos', 'Bellossom', 'Marill', 'Azumarill', 'Sudowoodo', 'Politoed', 'Hoppip', 'Skiploom', 'Jumpluff', 'Aipom', 'Sunkern', 'Sunflora', 'Yanma', 'Wooper', 'Quagsire', 'Murkrow', 'Slowking', 'Misdreavus', 'Unown', 'Wobbuffet', 'Girafarig', 'Pineco', 'Forretress', 'Dunsparce', 'Gligar', 'Steelix', 'Snubbull', 'Granbull', 'Qwilfish', 'Scizor', 'Shuckle', 'Heracross', 'Sneasel', 'Teddiursa', 'Ursaring', 'Slugma', 'Magcargo', 'Swinub', 'Piloswine', 'Corsola', 'Remoraid', 'Octillery', 'Delibird', 'Mantine', 'Skarmory', 'Houndour', 'Houndoom', 'Kingdra', 'Phanpy', 'Donphan', 'Porygon2', 'Stantler', 'Smeargle', 'Tyrogue', 'Hitmontop', 'Smoochum', 'Elekid', 'Magby', 'Miltank', 'Blissey', 'Raikou', 'Entei', 'Suicune', 'Larvitar', 'Pupitar', 'Tyranitar', 'Lugia', 'Ho Oh', 'Celebi', 'Treecko', 'Grovyle', 'Sceptile', 'Combusken', 'Blaziken', 'Marshtomp', 'Swampert', 'Poochyena', 'Mightyena', 'Zigzagoon', 'Linoone', 'Wurmple', 'Silcoon', 'Beautifly', 'Cascoon', 'Dustox', 'Lotad', 'Lombre', 'Ludicolo', 'Seedot', 'Nuzleaf', 'Shiftry', 'Taillow', 'Swellow', 'Wingull', 'Pelipper', 'Ralts', 'Kirlia', 'Gardevoir', 'Surskit', 'Masquerain', 'Shroomish', 'Breloom', 'Slakoth', 'Vigoroth', 'Slaking', 'Nincada', 'Ninjask', 'Shedinja', 'Whismur', 'Loudred', 'Exploud', 'Makuhita', 'Hariyama', 'Azurill', 'Nosepass', 'Skitty', 'Delcatty', 'Sableye', 'Mawile', 'Aron', 'Lairon', 'Aggron', 'Meditite', 'Medicham', 'Electrike', 'Manectric', 'Plusle', 'Minun', 'Volbeat', 'Illumise', 'Roselia', 'Gulpin', 'Swalot', 'Carvanha', 'Sharpedo', 'Wailmer', 'Wailord', 'Numel', 'Camerupt', 'Torkoal', 'Spoink', 'Grumpig', 'Spinda', 'Trapinch', 'Vibrava', 'Flygon', 'Cacnea', 'Cacturne', 'Swablu', 'Altaria', 'Zangoose', 'Seviper', 'Lunatone', 'Solrock', 'Barboach', 'Whiscash', 'Corphish', 'Crawdaunt', 'Baltoy', 'Claydol', 'Lileep', 'Cradily', 'Anorith', 'Armaldo', 'Feebas', 'Milotic', 'Castform', 'Kecleon', 'Shuppet', 'Banette', 'Duskull', 'Dusclops', 'Tropius', 'Chimecho', 'Absol', 'Wynaut', 'Snorunt', 'Glalie', 'Spheal', 'Sealeo', 'Walrein', 'Clamperl', 'Huntail', 'Gorebyss', 'Relicanth', 'Luvdisc', 'Bagon', 'Shelgon', 'Salamence', 'Beldum', 'Metang', 'Metagross', 'Regirock', 'Regice', 'Registeel', 'Latias', 'Latios', 'Kyogre', 'Groudon', 'Rayquaza', 'Jirachi', 'Deoxys',
].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

export const spriteUrl = (name) => `/Pokemons%20individual/${name}.png`;
export const spriteName = (name) =>
  name.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');

export const TRAINER_SPRITES = [
  'Ash', 'Boy_Grad_Student', 'Boy_Trainer', 'Brock', 'Girl_Grad_Student', 'Girl_Trainer', 'Misty', 'Pokeball',
];
export const trainerName = (name) =>
  name.replace(/_/g, ' ').split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');

// `fullId` points at the matching non-watermarked, full-resolution background in
// `public/Backgrounds full/` — used only for the generated PNG/PSD order files
// (see captureAndUpload/uploadPsd in PokemonCard.js). `id` (watermarked) stays the
// one shown in the live on-screen preview. Proposal has no non-watermarked source
// yet, so it falls back to the watermarked image for generation too.
export const BACKGROUNDS = [
  { id: 'backgrounds/Sunflower_House_Home_Background_w.webp', fullId: 'Backgrounds%20full/Sunflower%20House%20Home%20background.png', label: 'Sunflower',     color: '#d4b840' },
  { id: 'backgrounds/Cherry_Blossom_background_w.webp',       fullId: 'Backgrounds%20full/Cherry%20Blossom%20background.png',         label: 'Cherry Blossom',color: '#f090a8' },
  { id: 'backgrounds/Beach_Card_Background_w.webp',           fullId: 'Backgrounds%20full/Beach%20Background.png',                    label: 'Beach',         color: '#40a8e0' },
  { id: 'backgrounds/Park_Background_w.webp',                 fullId: 'Backgrounds%20full/Park%20Background.png',                     label: 'Park',          color: '#6aad5a' },
  { id: 'backgrounds/Fathers_day_Background_w.webp',          fullId: 'Backgrounds%20full/Fathers%20day%20Background.png',            label: "Father's Day",  color: '#5c8fc0' },
  { id: 'backgrounds/Bday_card_Background_w.webp',            fullId: 'Backgrounds%20full/Birthday%20Background.png',                 label: 'Birthday',      color: '#c46ab0' },
  { id: 'backgrounds/Proposal_Card_Background_w.webp',       fullId: null,                                                             label: 'Proposal',      color: '#b8c9bf' },
  { id: 'backgrounds/Fall_Autumn_Background_w.webp',         fullId: 'Backgrounds%20full/Autumn%20Fall%20House%20background.png',     label: 'Fall',          color: '#c2601a' },
  { id: 'backgrounds/Halloween_Background_w.webp',           fullId: 'Backgrounds%20full/Halloween%20Background.png',                 label: 'Halloween',     color: '#5a1a8a' },
  { id: 'backgrounds/Graduation_Card_Background_w.webp',    fullId: 'Backgrounds%20full/Graduation%20Background.png',                label: 'Graduation',    color: '#8b7355' },
];

// Suggested starting layout seeded when a background/preset is applied. Customers can then
// freely drag, resize, rotate, add or remove sprites from there — this is just a starting point.
// `positions` lets a specific preset override where its trainers/pokémon start out (see
// PRESETS['backgrounds/Graduation_Card_Background_w.webp'].positions below) instead of using
// the shared defaults.
const defaultSpriteSeed = (trainers, pokemons, positions) => {
  const trainerXY = positions?.trainerXY ?? [
    { x: 110,  y: 150, flip: false },
    { x: 179, y: 150, flip: true  },
    { x: 145, y: 128, flip: false },
  ];
  const pokemonXY = positions?.pokemonXY ?? [
    { x: 72,  y: 155, flip: true },
    { x: 216, y: 155, flip: false  },
    { x: 145, y: 90, flip: false },
  ];
  const sprites = [];
  let z = 1;
  trainers.filter(Boolean).forEach((t, i) => {
    const p = trainerXY[i] || trainerXY[0];
    sprites.push({ ...createSprite('trainer', t, { x: p.x, y: p.y, z: z++ }), flip: p.flip });
  });
  pokemons.filter(Boolean).forEach((p2, i) => {
    const p = pokemonXY[i] || pokemonXY[0];
    sprites.push({ ...createSprite('pokemon', p2, { x: p.x, y: p.y, z: z++ }), flip: p.flip });
  });
  return sprites;
};

const ANNIVERSARY_PRESET = {
  name:       'The Anniversary',
  hp:         '365',
  bannerText: "The rarest catch of 'em all",
  atk1Name:   'I Choose You',
  atk1Dmg:    '100',
  atk1Desc:   'Cheers to leveling up our love and happiness together!',
  message:    'Happy Anniversary!',
};

// Beach art has less headroom below the water line than the other Anniversary
// backgrounds, so its sprites start higher up (smaller y) than the shared defaults.
const BEACH_POSITIONS = {
  trainerXY: [
    { x: 110, y: 95, flip: false },
    { x: 179, y: 95, flip: true  },
    { x: 145, y: 95, flip: false },
  ],
  pokemonXY: [
    { x: 72,  y: 95, flip: true },
    { x: 216, y: 95, flip: false  },
    { x: 145, y: 95, flip: false },
  ],
};

const PRESETS = {
  'backgrounds/Sunflower_House_Home_Background_w.webp': ANNIVERSARY_PRESET,
  'backgrounds/Cherry_Blossom_background_w.webp':       ANNIVERSARY_PRESET,
  'backgrounds/Beach_Card_Background_w.webp':           { ...ANNIVERSARY_PRESET, positions: BEACH_POSITIONS },
  'backgrounds/Park_Background_w.webp':                 ANNIVERSARY_PRESET,
  'backgrounds/Fathers_day_Background_w.webp': {
    name:       "Happy Father's Day",
    hp:         '365',
    bannerText: 'A special day for a legendary hero!',
    atk1Name:   'I Choose You',
    atk1Dmg:    '100',
    atk1Desc:   'Congratulations on being the very best dad ever!',
    message:    "Wishing you a happy father's day!",
  },
  'backgrounds/Bday_card_Background_w.webp': {
    name:       'Happy Birthday',
    hp:         '365',
    bannerText: "The legendary catch of 'em all!",
    atk1Name:   'I Choose You',
    atk1Dmg:    '100',
    atk1Desc:   'Congratulations to leveling up another year!',
    message:    'Wishing you a very special happy birthday!',
  },
  'backgrounds/Proposal_Card_Background_w.webp': {
    name:       'The Proposal',
    hp:         '365',
    bannerText: "The very best catch of 'em all!",
    atk1Name:   'I Choose You',
    atk1Dmg:    '100',
    atk1Desc:   'Will you marry me?',
    message:    'I love you!',
  },
  'backgrounds/Fall_Autumn_Background_w.webp': ANNIVERSARY_PRESET,
  'backgrounds/Halloween_Background_w.webp': {
    name:       'Happy Halloween',
    hp:         '365',
    bannerText: "The spookiest catch of 'em all!",
    atk1Name:   'Trick or Treat',
    atk1Dmg:    '100',
    atk1Desc:   "Boo! You've been caught by the scariest trainer around!",
    message:    'Happy Halloween!',
  },
  'backgrounds/Graduation_Card_Background_w.webp': {
    name:          'The Graduation',
    hp:            '365',
    bannerText:    'Happy Graduation Day!',
    atk1Name:      'I Choose You',
    atk1Dmg:       '100',
    atk1Desc:      'You made it! Thank you to all the friends, family, and teachers that came along the journey to celebrate this special day!',
    message:       'Cheers to the memories you will cherish forever!',
    trainers:      ['Boy_Grad_Student', 'Girl_Grad_Student'],
    pokemons:      [],
    // No pokémon sprites on this preset, so the two students get their own closer,
    // centered starting layout instead of the shared trainerXY defaults above.
    positions: {
      trainerXY: [
        { x: 190, y: 80, flip: false },
        { x: 230, y: 80, flip: true  },
      ],
    },
  },
};

export const TYPE_MAP = {
  Electric: '⚡', Fire: '🔥', Water: '💧', Grass: '🌿', Normal: '⭐',
  Psychic: '🔮', Fighting: '🥊', Ice: '❄️', Dragon: '🐉', Dark: '🌑',
};

function App() {
  // Detect /shopify entry path, store source, then redirect to root
  const [referralSource] = useState(() => {
    if (window.location.pathname === '/shopify') {
      sessionStorage.setItem('referralSource', 'shopify');
      window.history.replaceState({}, '', '/');
      return 'shopify';
    }
    return sessionStorage.getItem('referralSource') || null;
  });

  const [bg, setBg]             = useState('backgrounds/Sunflower_House_Home_Background_w.webp');
  const [name, setName]         = useState('The Anniversary');
  const [hp, setHp]             = useState('365');
  const [bannerText, setBannerText] = useState("The rarest catch of 'em all");
  const [message, setMessage]       = useState('Happy Anniversary!');
  const [atk1Name, setAtk1Name] = useState('I Choose You');
  const [atk1Dmg, setAtk1Dmg]  = useState('100');
  const [atk1Desc, setAtk1Desc] = useState('Cheers to leveling up our love and happiness together!');
  const [atk2Name, setAtk2Name] = useState('Agility');
  const [atk2Dmg, setAtk2Dmg]  = useState('30');

  // Freely-placed sprite instances (trainers + pokémon), any count, drag/resize/rotate on the card
  const [sprites, setSprites]     = useState(() => defaultSpriteSeed(['Boy_Trainer', 'Girl_Trainer'], ['Pikachu', 'Charmander']));
  const [selectedId, setSelectedId] = useState(null);

  // Preload all background images on mount so switching is instant
  useEffect(() => {
    BACKGROUNDS.forEach(b => {
      const img = new Image();
      img.src = `/${b.id}`;
    });
  }, []);

  const [presetPrompt, setPresetPrompt] = useState(null);
  const hasUserEdited = useRef(false);
  const track = (setter) => (val) => { hasUserEdited.current = true; setter(val); };

  const addSprite = (kind, name) => {
    hasUserEdited.current = true;
    const jitter = sprites.length % 4;
    const s = createSprite(kind, name, {
      x: CARD_W / 2 + jitter * 8,
      y: CARD_H / 2 + jitter * 8,
      z: nextZ(sprites),
    });
    setSprites(prev => [...prev, s]);
    setSelectedId(s.id);
  };
  const updateSprite = (id, patch) => {
    hasUserEdited.current = true;
    setSprites(prev => prev.map(s => (s.id === id ? { ...s, ...patch } : s)));
  };
  const deleteSprite = (id) => {
    hasUserEdited.current = true;
    setSprites(prev => prev.filter(s => s.id !== id));
    setSelectedId(sel => (sel === id ? null : sel));
  };
  const resetSprites = () => {
    hasUserEdited.current = true;
    setSprites(defaultSpriteSeed(['Boy_Trainer', 'Girl_Trainer'], ['Pikachu', 'Charmander']));
    setSelectedId(null);
  };
  const applyPreset = (id) => {
    const p = PRESETS[id];
    if (!p) return;
    setName(p.name);         setHp(p.hp);
    setBannerText(p.bannerText);
    setAtk1Name(p.atk1Name); setAtk1Dmg(p.atk1Dmg); setAtk1Desc(p.atk1Desc);
    setMessage(p.message);
    setSprites(defaultSpriteSeed(p.trainers ?? ['Boy_Trainer', 'Girl_Trainer'], p.pokemons ?? ['Pikachu', 'Charmander'], p.positions));
    setSelectedId(null);
    hasUserEdited.current = false;
  };

  const handleBgChange = (id) => {
    setBg(id);
    if (PRESETS[id]) {
      if (!hasUserEdited.current) {
        applyPreset(id);
      } else {
        setPresetPrompt(id);
      }
    }
  };

  const pokemon = POKEMON[0];
  const bgObj   = BACKGROUNDS.find(b => b.id === bg) || BACKGROUNDS[0];

  return (
    <>
      {/* Pokéball Background Watermarks */}
      <div className="pokeball-bg">
        <svg width="320" height="320" viewBox="0 0 100 100" style={{ top: '-40px', left: '-60px' }}>
          <circle cx="50" cy="50" r="48" fill="none" stroke="#8b6340" strokeWidth="5"/>
          <line x1="2" y1="50" x2="98" y2="50" stroke="#8b6340" strokeWidth="5"/>
          <circle cx="50" cy="50" r="14" fill="none" stroke="#8b6340" strokeWidth="5"/>
          <circle cx="50" cy="50" r="7" fill="#8b6340"/>
        </svg>
        <svg width="260" height="260" viewBox="0 0 100 100" style={{ top: '30%', right: '-40px' }}>
          <circle cx="50" cy="50" r="48" fill="none" stroke="#8b6340" strokeWidth="5"/>
          <line x1="2" y1="50" x2="98" y2="50" stroke="#8b6340" strokeWidth="5"/>
          <circle cx="50" cy="50" r="14" fill="none" stroke="#8b6340" strokeWidth="5"/>
          <circle cx="50" cy="50" r="7" fill="#8b6340"/>
        </svg>
        <svg width="200" height="200" viewBox="0 0 100 100" style={{ bottom: '5%', left: '30%' }}>
          <circle cx="50" cy="50" r="48" fill="none" stroke="#8b6340" strokeWidth="5"/>
          <line x1="2" y1="50" x2="98" y2="50" stroke="#8b6340" strokeWidth="5"/>
          <circle cx="50" cy="50" r="14" fill="none" stroke="#8b6340" strokeWidth="5"/>
          <circle cx="50" cy="50" r="7" fill="#8b6340"/>
        </svg>
      </div>

      {/* Nav */}
      <nav>
        <div className="nav-store-links">
          <a href="https://toastytrainers.com" target="_blank" rel="noopener noreferrer" title="Shop on Shopify" className="nav-store-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="#96BF48" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.337 23.979l7.216-1.561s-2.604-17.613-2.625-17.73c-.018-.116-.114-.192-.211-.192s-1.929-.136-1.929-.136-1.275-1.274-1.439-1.411c-.045-.037-.075-.057-.121-.074l-.914 21.104h.023zM11.71 11.305s-.81-.424-1.774-.424c-1.447 0-1.504.906-1.504 1.141 0 1.232 3.24 1.715 3.24 4.629 0 2.295-1.44 3.76-3.406 3.76-2.354 0-3.54-1.465-3.54-1.465l.646-2.086s1.245 1.066 2.28 1.066c.675 0 .975-.545.975-.932 0-1.619-2.654-1.694-2.654-4.359-.034-2.237 1.571-4.416 4.827-4.416 1.257 0 1.875.361 1.875.361l-.945 2.715-.02.01zM11.17.83c.136 0 .271.038.405.135-.984.465-2.064 1.639-2.508 3.992-.656.213-1.293.405-1.889.578C7.697 3.75 8.951.84 11.17.84V.83zm1.235 2.949v.135c-.754.232-1.583.484-2.394.736.466-1.777 1.333-2.645 2.085-2.971.193.501.309 1.176.309 2.1zm.539-2.234c.694.074 1.141.867 1.429 1.755-.349.114-.735.231-1.158.366v-.252c0-.752-.096-1.371-.271-1.871v.002zm2.992 1.289c-.02 0-.06.021-.078.021s-.289.075-.714.21c-.423-1.233-1.176-2.37-2.508-2.37h-.115C12.135.209 11.669 0 11.265 0 8.159 0 6.675 3.877 6.21 5.846c-1.194.365-2.063.636-2.16.674-.675.213-.694.232-.772.87-.075.462-1.83 14.063-1.83 14.063L15.009 24l.927-21.166z"/>
            </svg>
          </a>
          <a href="https://toastytrainers.etsy.com" target="_blank" rel="noopener noreferrer" title="Shop on Etsy" className="nav-store-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="#F16521" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.559 2.445c0-.325.033-.52.59-.52h7.465c1.3 0 2.02 1.11 2.54 3.193l.42 1.666h1.27c.23-4.728.43-6.784.43-6.784s-3.196.36-5.09.36H6.635L1.521.196v1.37l1.725.326c1.21.24 1.5.496 1.6 1.606 0 0 .11 3.27.11 8.64 0 5.385-.09 8.61-.09 8.61 0 .973-.39 1.333-1.59 1.573l-1.722.33V24l5.13-.165h8.55c1.935 0 6.39.165 6.39.165.105-1.17.75-6.48.855-7.064h-1.2l-1.284 2.91c-1.005 2.28-2.476 2.445-4.11 2.445h-4.906c-1.63 0-2.415-.64-2.415-2.05V12.8s3.62 0 4.79.096c.912.064 1.463.325 1.76 1.598l.39 1.695h1.41l-.09-4.278.192-4.305h-1.391l-.45 1.89c-.283 1.244-.48 1.47-1.754 1.6-1.666.17-4.815.14-4.815.14V2.45h-.05z"/>
            </svg>
          </a>
        </div>
      </nav>

      {/* Page */}
      <div className="page">
        <div className="page-header">
          <div className="toast-badge">🍞 Create Your Custom Card</div>
          <h1>Design Your Moment</h1>
          <p>Craft a one-of-a-kind collectible card to celebrate your special occasion</p>
        </div>

        <div className="main-layout">
          <PokemonCard
            pokemon={pokemon}
            bgObj={bgObj}
            name={name}
            hp={hp}
            bannerText={bannerText}
            message={message}
            atk1Name={atk1Name}
            atk1Dmg={atk1Dmg}
            atk1Desc={atk1Desc}
            atk2Name={atk2Name}
            atk2Dmg={atk2Dmg}
            sprites={sprites}
            POKEMON_SPRITES={POKEMON_SPRITES}
            selectedId={selectedId}
            setSelectedId={setSelectedId}
            onSpriteChange={updateSprite}
            onSpriteDelete={deleteSprite}
            referralSource={referralSource}
          />
          <CustomizationPanel
            bg={bg}               setBg={handleBgChange}
            name={name}           setName={track(setName)}
            hp={hp}               setHp={track(setHp)}
            bannerText={bannerText} setBannerText={track(setBannerText)}
            message={message}     setMessage={track(setMessage)}
            atk1Name={atk1Name}   setAtk1Name={track(setAtk1Name)}
            atk1Dmg={atk1Dmg}     setAtk1Dmg={track(setAtk1Dmg)}
            atk1Desc={atk1Desc}   setAtk1Desc={track(setAtk1Desc)}
            atk2Name={atk2Name}   setAtk2Name={track(setAtk2Name)}
            atk2Dmg={atk2Dmg}     setAtk2Dmg={track(setAtk2Dmg)}
            sprites={sprites}
            addSprite={addSprite}
            updateSprite={updateSprite}
            deleteSprite={deleteSprite}
            resetSprites={resetSprites}
            selectedId={selectedId}
            setSelectedId={setSelectedId}
            bgObj={bgObj}
            BACKGROUNDS={BACKGROUNDS}
            POKEMON_SPRITES={POKEMON_SPRITES}   spriteName={spriteName}
            TRAINER_SPRITES={TRAINER_SPRITES}   trainerName={trainerName}
          />
        </div>
      </div>

      {presetPrompt && (
        <div className="preset-prompt-overlay" onClick={() => setPresetPrompt(null)}>
          <div className="preset-prompt" onClick={e => e.stopPropagation()}>
            <p className="preset-prompt-msg">
              Apply the <strong>{BACKGROUNDS.find(b => b.id === presetPrompt)?.label}</strong> card template?
            </p>
            <p className="preset-prompt-sub">This will fill in suggested card text and sprite placement. You can edit it afterwards.</p>
            <div className="preset-prompt-actions">
              <button className="preset-btn preset-btn-yes" onClick={() => { applyPreset(presetPrompt); setPresetPrompt(null); }}>
                Yes, apply template
              </button>
              <button className="preset-btn preset-btn-no" onClick={() => setPresetPrompt(null)}>
                No, keep my design
              </button>
            </div>
          </div>
        </div>
      )}
      <Analytics />
    </>
  );
}

export default App;
